// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"171":"f5b85272","520":"e65409a1"}[chunkId] || chunkId) + "." + {"171":"88c5c30ab5c2f254","313":"10e5b674a232a394","367":"bd4d1211bbad1f0d","520":"88f046cd6ce1c8e1"}[chunkId] + ".js";
};